<template>
  <div class="mt-5">
    <b-row class="mt-5 mb-1">
      <b-col>
        <h2>
          <span class="dbb-red">Tview</span> 
        </h2>
      </b-col>
    </b-row>

    <b-row class="my-1" v-if="paramArg === 'demo01'">
      <b-col>
        <p>
          <i>Tview</i> is an open access visualisation platform designed to show high resolution microscopy and (comparatively) low resolution MRI in one place. Click to zoom, hold to pan, and use the buttons on the top right to select and overlay different images.
        </p>
      </b-col>
    </b-row>

    <div v-show="showMap" class='pb-4 mb-4' id="map"></div>

    <b-row class="my-4 mx-1" no-gutters>
      <b-col>
        <h3 v-if="dataset !== null && paramArg !== 'demo01'">{{ dataset.datasetTitle }}</h3>
        <p style="white-space: pre-wrap" v-if="dataset !== null">{{ dataset.viewerTextDescription }}</p>
      </b-col>
    </b-row>
    <b-carousel class="my-5" v-if="dataset !== null && dataset.viewerStaticImages.length>0"
      v-model="slide"
      :controls="dataset.viewerStaticImages.length>1"
      :indicators="dataset.viewerStaticImages.length>1"
      img-height=300
      >
      <b-carousel-slide v-for="(staticImage, index) in dataset.viewerStaticImages" :key="index"
        :img-src="staticImage.url"
        img-height=300
        caption="">
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
//import * as dbblib from "@/dbblib.js";
/*
The TileViewer component shows Leafletjs TileLayers.

*/
import * as L from "leaflet";
import "leaflet.control.opacity";
import axios from 'axios'

export default {
  props: {
  },
  name: "tileviewer",
  data() {
    return {
      slide: 0,
      param: 'datasetTitle',
      paramArg: 'demo01',
      dataset: null,
      showMap: true
      //tv_dataid: this.dataid || localStorage.getItem("dataid"),
      //tv_tiles: this.dataset.viewer_tiles, //this.tiles || localStorage.getItem("tiles"),
      //tv_min_zoom: this.dataset.min_zoom,//this.min_zoom || localStorage.getItem("min_zoom"),
      //tv_max_zoom: this.dataset.max_zoom,//this.max_zoom || localStorage.getItem("max_zoom"),
    };
  },
  computed: {
    // hasStaticImg: function() {
    //   return (this.staticImgSrc === '' ? false : true)
    // }
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        location.reload()
      }
      //this.kind = this.$route.params.kind
    }
  }, 
  mounted() {
    /* 
    if (this.dataid) {
      localStorage.setItem("dataid", this.dataid)
    }
    if (this.tiles) {
      localStorage.setItem("tiles", this.tiles)
    }
    if (this.min_zoom) {
      localStorage.setItem("min_zoom", this.min_zoom)
    }
    if (this.max_zoom) {
      localStorage.setItem("max_zoom", this.max_zoom)
    }
    */

    this.getDataset()
    
  },
  methods: {
    updateViewer() {
      if (this.dataset.viewerTiles.length <1) {
        this.showMap = false
      }
      // var yx = L.latLng;

      // var xy = function (x, y) {
      //   if (L.Util.isArray(x)) {
      //     // When doing xy([x, y]);
      //     return yx(x[1], x[0]);
      //   }
      //   return yx(y, x); // When doing xy(x, y);
      // };

      L.CRS.MySimple = L.extend({}, L.CRS.Simple, {
        //                      coefficients: a      b    c     d
        transformation: new L.Transformation(1 / 2**Number(6), 0, 1 / 2**Number(6), 0) // Compute a and c coefficients so that  tile 0/0/0 is from [0, 0] to [img]
      })

      // var bounds = [xy(0, 0), xy([10000,10000])]

      var viewer = L.map("map", {
        center: [5000, 5000],
        zoom: 3,
        crs: L.CRS.MySimple,
        // maxBounds: bounds,
        attributionControl: false,
      })

      // viewer.fitBounds(bounds)

      // var baseLayer = L.tileLayer(
      //   `${dbblib.API_TILES}/${this.dataid}/${this.tv_tileList[0]}/{z}/{y}/{x}`,
      //   {
      //     maxZoom: this.dataset.max_zoom,
      //     minZoom: this.dataset.min_zoom,
      //     noWrap: true,
      //     // bounds: bounds,
      //   }
      // );
      
      // loop over
      var overlayLayers = {}
      var baseLayers = {}
      var baseLayer = {}
      this.dataset.viewerTiles.forEach((tile) => {
        var ovlay = L.tileLayer(
          `${tile.url}/{z}/{y}/{x}`,
          {
            minZoom: 0,
            maxZoom: 6,
            noWrap: true,
            // bounds: bounds,
          }
        );
        if (!tile.isBaseLayer) {
          overlayLayers[`${tile.displayName}`] = ovlay;
        } else {
          baseLayers[`${tile.displayName}`] = ovlay
          baseLayer = ovlay
        }
      });
      baseLayer.addTo(viewer);
      L.control
        .layers(baseLayers, overlayLayers, { collapsed: true })
        .addTo(viewer);
      L.control
        .opacity(overlayLayers, { label: "", collapsed: true })
        .addTo(viewer);

      // L.control.scale().addTo(viewer);

    },
    getDataset() {
      // dbblib.getDataset(this.dataid)
      // .then(response => response.json()) 
      // .then(json_data => this.dataset= json_data.payload)
      this.param = 'datasetTitle'
      this.paramArg = 'demo01'
      console.log(this.$route.params.id)
      // if (this.$route.params.id === undefined){
      //   this.param = 'id'
      //   this.paramArg = this.$route.params.id
      // }

      if (this.$route.params.id) {
        this.param = 'id'
        this.paramArg = this.$route.params.id
      }
      
      axios.get('/DigitalBrainBank/datasets', {
        params: {
          [`${this.param}`]: this.paramArg
        }
      })
      .then((response) => {
        console.log(response)
        if ('success' in response.data){
          console.log(response.data.success)
          this.dataset = response.data.success
          this.updateViewer()
        } else {
          console.log(response.data)
        }
      }, (error) => {
        console.log(error)
      })
    },
    makeTileList() {
      //this.tv_tileList = dbblib.fileListFromString(this.dataset.viewer_tiles)
    },
    reload() {
      // could use console.log(location.hash) to reload a previous state just from the URL 
      // in that case, you would only store the url hash location in localstorage
      //this.$router.push("/tileviewer/2")
      location.reload()
    }
  },
  created() {},
};
</script>

<style scoped>
#map {
  height: 600px;
}

.dbb-red {
  color: #8b2a34;
}
</style>
